export const endpoints = {
    'auth_login'            : 'dev/auth/login',
    'auth_logout'           : 'dev/profile/logout',
    'auth_register'         : 'dev/auth/register',
    'auth_password_forgot'  : 'dev/auth/forgotPassword',
    'auth_password_reset'   : 'dev/auth/resetPassword',
    'auth_password_check'   : 'dev/auth/checkResetToken',
    'auth_google_verify'    : 'dev/auth/googleVerify',
    'app_get'               : 'dev/apps/get',
    'app_insert'            : 'dev/apps/save',
    'app_detail'            : 'dev/apps/detail',
    'app_module_get'        : 'dev/apps/getModules',
    'app_module_set'        : 'dev/apps/setModule',
    'app_module_update'     : 'dev/apps/updateModule',
    'app_module_delete'     : 'dev/apps/deleteModule',
    'app_module_setting_get': 'dev/apps/getSettingKeys',
    'app_price_update'      : 'dev/apps/updatePrice',
    'app_other_update'      : 'dev/apps/updateOther',
    'app_package_all_get'   : 'dev/apps/getPackages',
    'app_package_get'       : 'dev/apps/getAppPackage',
    'app_package_set'       : 'dev/apps/setAppPackage',
    'app_package_update'    : 'dev/apps/updateAppPackage',
    'app_package_delete'    : 'dev/apps/deleteAppPackage',
    'app_currency_get'      : 'dev/apps/getCurrencies',
    'app_inputs_all_get'    : 'dev/apps/getInputs',
    'app_inputs_get'        : 'dev/apps/getInputsById',
    'app_inputs_set'        : 'dev/apps/setInputs',
    'app_inputs_update'     : 'dev/apps/updateInputs',
    'app_inputs_delete'     : 'dev/apps/deleteInputs',
    'app_review_update'     : 'dev/apps/changeReview',
    'app_review_root_update': 'dev/apps/changeReviewRoot',
    'app_review_changes_get': 'dev/apps/getChanges',
    'app_active_set'        : 'dev/apps/setActive',
    'app_draft_set'         : 'dev/apps/setDraft',
    'app_general_update'    : 'dev/apps/generalUpdate',
    'app_seo_update'        : 'dev/apps/seoUpdate',
    'app_images_get'        : 'dev/images/getAllByAppId',
    'app_images_set'        : 'dev/images/set',
    'app_images_update'     : 'dev/images/update',
    'app_images_delete'     : 'dev/images/deleteImage',
    'app_images_logo_set'   : 'dev/images/setLogo',
    'categories_get'        : 'dev/categories/get',
    'permissions_get'       : 'dev/permissions/get',
    'profile_get'           : 'dev/profile/get',
    'profile_set'           : 'dev/profile/setProfile',
    'profile_account_set'   : 'dev/profile/setAccount',
    'profile_invoice_set'   : 'dev/profile/setInvoice',
    'profile_password_set'  : 'dev/profile/setPassword',
    'profile_language_set'  : 'dev/profile/setLanguage',
    'coupon_get'            : 'dev/coupon/get',
    'coupon_set'            : 'dev/coupon/createCoupon',
    'coupon_domain_get'     : 'dev/coupon/getDomains',
    'coupon_apps_get'       : 'dev/coupon/getApps',
    'coupon_isDeveloper'    : 'dev/coupon/isDeveloper',
    'order_get'             : 'dev/order/getOrders',
    'order_domain_get'      : 'dev/order/getDomains',
    'order_apps_get'        : 'dev/order/getApps',
    'order_detail'          : 'dev/order/detail',
    'order_sales_get'       : 'dev/order/getSales',
    'coupon_getCouponCode'  : 'dev/coupon/createCouponCode',
    'releaseNotes_getByApp' : 'dev/releaseNotes/getAllByAppId',
    'releaseNotes_set'      : 'dev/releaseNotes/set',
    'releaseNotes_update'   : 'dev/releaseNotes/update',
    'releaseNotes_delete'   : 'dev/releaseNotes/deleteNote',
    'developer_chart'       : 'dev/statistics/getDeveloperStatistics',
    'developer_total'       : 'dev/statistics/totalDeveloperCount',
    'developer_approved'    : 'dev/statistics/approvedDeveloperCount',
    'developer_unapproeved' : 'dev/statistics/unapprovedDeveloperCount',
    'app_chart'             : 'dev/statistics/getAppStatistics',
    'app_total'             : 'dev/statistics/totalAppCount',
    'app_free'              : 'dev/statistics/freeAppCount',
    'app_paid'              : 'dev/statistics/paidAppCount',
    'sale_chart'            : 'dev/statistics/getSaleStatistics',
    'sale_total'            : 'dev/statistics/totalSaleCount',
    'sale_cancelled'        : 'dev/statistics/cancelledSaleCount',
    'sale_total_price'      : 'dev/statistics/totalSalePriceAmount',
    'customer_chart'        : 'dev/statistics/getCustomerStatistics',
    'customer_total'        : 'dev/statistics/totalCustomerCount',
    'customer_paid_buyer'   : 'dev/statistics/paidAppBuyer',
    'customer_installed'    : 'dev/statistics/totalAppInstalled',
    'comment_get'           : 'dev/appComments/getAppComments',
    'comment_delete'        : 'dev/appComments/deleteComment',
    'comment_edit'          : 'dev/appComments/editComments',
    'comment_update'        : 'dev/appComments/changeCommentApproval',
    'installs_get'          : 'dev/installs/getTable',
    'installs_get_domains'  : 'dev/installs/getDomains',
    'installs_get_apps'     : 'dev/installs/getAppNames',
    'common_get_apps'       : 'dev/apps/getAppNames',
    'common_get_domains'    : 'dev/domain/getDomains',
    'dashboard_total_app'   : 'dev/dashboard/totalApps',
    'dashboard_total_dev'   : 'dev/dashboard/totalDeveloper',
    'dashboard_total_rev'   : 'dev/dashboard/totalReviews',
    'dashboard_total_user'  : 'dev/dashboard/totalUser',
    'dashboard_sale_stats'  : 'dev/dashboard/saleStatistics',
    'dashboard_most_sale'   : 'dev/dashboard/mostSaleApps',
    'dashboard_most_install': 'dev/dashboard/topInstalledApps',
    'sale_perf_total'       : 'dev/salePerformance/totalRavenue',
    'developer_page_get'    : 'dev/developers/getDevelopers',
    'developer_page_detail' : 'dev/developers/get',
    'developer_page_state'  : 'dev/developers/updateAccountState',
    'developer_page_user'   : 'dev/developers/setProfile',
    'developer_page_invoice': 'dev/developers/setInvoice',
    'developer_accounnt'    : 'dev/developers/setAccount',
    'dashboard_statistics'  : 'statistics',
    'tasks_get'             : 'dev/tasks/get',
    'tasks_complete_toggle' : 'dev/tasks/toggleComplete',
    'reviews_processes_get' : 'dev/reviews/getProcesses',
    'notifications_get'     : 'dev/notifications/get',
    'notifications_read'    : 'dev/notifications/read',
    'notifications_allread' : 'dev/notifications/allRead',
    'ticket_get'            : 'dev/ticket/getData',
    'ticket_create'         : 'dev/ticket/create',
    'ticket_detail'         : 'dev/ticket/detail',
    'ticket_add'            : 'dev/ticket/add',
    'usage_get'             : 'dev/applicationUsage/get', 
    'usage_get_years'       : 'dev/applicationUsage/years', 
    'demos_get_table'       : 'dev/demos/getTable', 
    'demos_delete'          : 'dev/demos/deleteRecord', 
    'demos_update'          : 'dev/demos/updateRecord', 
    'demos_developers'      : 'dev/demos/getDevelopers', 
    'demos_create'          : 'dev/demos/createDemo', 
    'demos_detail'          : 'dev/demos/demoDetail', 
    'demos_update_demo'     : 'dev/demos/updateDemo', 
    'banners_get'           : 'dev/banners/getTable', 
    'banners_detail'        : 'dev/banners/detail', 
    'banners_delete'        : 'dev/banners/deleteRecord', 
    'banners_update'        : 'dev/banners/updateStatus', 
    'banners_set'           : 'dev/banners/set', 
    'banners_create'        : 'dev/banners/create', 
    'banners_update_record' : 'dev/banners/updateRecord', 
    'dev_perms_get'         : 'dev/devPermissions/getPermissions',
    'dev_perms_group_get'   : 'dev/devPermissions/get',
    'dev_perms_table_get'   : 'dev/devPermissions/getGroups',
    'dev_perms_group_set'   : 'dev/devPermissions/setGroup',
    'dev_perms_methods_get' : 'dev/devPermissions/getMethods',
    'dev_perms_set'         : 'dev/devPermissions/save',
    'dev_perms_delete'      : 'dev/devPermissions/delete',
    'domain'                : {
        'get'            : 'dev/domain/get',
        'set'            : 'dev/domain/set',
        'del'            : 'dev/domain/remove'
    },
    'categories_get_table'    : 'dev/categories/getTable',
    'categories_change_status': 'dev/categories/updateStatus',
    'categories_delete'       : 'dev/categories/deleteRecord',
    'categories_create'       : 'dev/categories/createCategory',
    'categories_update'       : 'dev/categories/updateCategory',
    'menu_get'                : 'dev/menu/get',
    'menu_set'                : 'dev/menu/set',
    'menu_update'             : 'dev/menu/update',
    'menu_delete'             : 'dev/menu/delete',
    'menu_table_get'          : 'dev/menu/getMenus',
    'manu_main_get'           : 'dev/menu/getMainMenus',
    'menu_detail_get'         : 'dev/menu/getMenuById',
    'menu_tree_get'           : 'dev/menu/getMenuTree',
    'menu_perm_ids_get'       : 'dev/menu/getPermIds',
    'menu_perms_set'          : 'dev/menu/setPerms'
}
